import { BrowserRouter } from "react-router-dom";
import AppRouter from "./AppRouter/AppRouter";
import Header from "./components/header/Header";
import ScrollToTop from "./utils/js/scrollToTop";
import { AuthProvider, useAuth } from "./providers/authProvider/AuthContext";
import {NotificationProvider} from "./providers/notificationProvider/NotificationProvider";
import {useNotificationsUpdater} from "./utils/hooks/useNotificationsUpdater/useNotificationsUpdater";
import {useClaimsNotifications} from "./pages/Claims/hooks/useClaimsNotifications";
import {useGetOrderCount} from "./pages/OrdersPage/hooks/useGetOrderCount/useGetOrderCount";

function AppContent() {

    const { isAuthenticated, logout } = useAuth();

    useNotificationsUpdater();
    useClaimsNotifications();
    /*useGetOrderCount();*/

    return (
        <>
            <ScrollToTop />
            {isAuthenticated && (
                <Header onLogout={logout} />
            )}
            <AppRouter />
        </>
    );
}

function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <NotificationProvider>
                    <AppContent />
                </NotificationProvider>
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;
